export const COOKIE_CONSENT_VERSION = 'v1';
export const COOKIE_CONSENT_STORAGE_KEY = 'hairchitech_cookie_consent';

export const COOKIE_CATEGORIES = {
  ESSENTIAL: 'essential',
  ANALYTICS: 'analytics',
  MARKETING: 'marketing'
};
